import React, { Component } from 'react'
import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'

class BlockedAccess extends Component {
  constructor(props) {
    super(props)
    this.state = {
      copied: false
    }
  }

  componentDidMount() {
    // Change URL to blocked route without page reload
    if (window.history && window.history.replaceState) {
      // Get context root from current URL
      let contextRoot = ''
      if (process.env.NODE_ENV === 'production') {
        const currentPath = window.location.pathname
        const firstSlashIndex = currentPath.indexOf('/', 1)
        if (firstSlashIndex > 0) {
          contextRoot = currentPath.substring(0, firstSlashIndex)
        }
      }
      const blockedUrl = `${contextRoot}/blocked`
      window.history.replaceState(null, '', blockedUrl)
    }
  }

  handleButtonClick = () => {
    window.location.href = 'https://www.fabrick.com/onboarding/fabrick/feweb/index.html#/contacts'
  }

  copyToClipboard = () => {
    const link = 'https://www.fabrick.com/onboarding/fabrick/feweb/index.html#/contacts'
    navigator.clipboard.writeText(link).then(() => {
      this.setState({ copied: true })
      setTimeout(() => {
        this.setState({ copied: false })
      }, 2000)
    })
  }

  render() {
    const { styles } = this.props
    const redirectUrl = 'https://www.fabrick.com/onboarding/fabrick/feweb/index.html#/contacts'

    return (
      <div {...css(styles.container)}>
        <div {...css(styles.content)}>
          <div {...css(styles.iconWrapper)}>
            <svg
              {...css(styles.warningIcon)}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 64 64"
              fill="none"
            >
              <circle cx="32" cy="32" r="30" fill="#f5e6d3" />
              <path
                d="M32 20v16m0 8h.02"
                stroke="#d97706"
                strokeWidth="4"
                strokeLinecap="round"
              />
            </svg>
          </div>
          <h1 {...css(styles.title)}>
            Questa pagina non esiste più, ma non viene abbandonato.
          </h1>
          <p {...css(styles.subtitle)}>
            Clicca qui sotto per continuare la registrazione
          </p>
          <button {...css(styles.button)} onClick={this.handleButtonClick}>
            Riprendi la registrazione
          </button>
          <div {...css(styles.tipSection)}>
            <p {...css(styles.tipLabel)}>Consiglio:</p>
            <p {...css(styles.tipText)}>
              salva il nuovo link per accedere direttamente alla tua registrazione in qualsiasi momento
            </p>
            <div {...css(styles.linkContainer)}>
              <span {...css(styles.link)}>{redirectUrl}</span>
              <span {...css(styles.copyLink)} onClick={this.copyToClipboard}>
                {this.state.copied ? 'Copiato!' : '(Copia)'}
              </span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withStyles(Styles)(BlockedAccess)



// WEBPACK FOOTER //
// ./components/blockedAccess/index.js